// Librairies
import { isAndroid, isChrome, isDesktop, isEdge, isFirefox, isIE, isIOS, isMacOs, isMobileOnly, isOpera, isSafari, isTablet, isWindows } from 'react-device-detect';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
// Services
import UsersService from '../services/UsersService';

export default class UsersUtil {
    static checkBillingAddress(billingAddress, isPro = false) {
        let isValid = false;

        if (isPro && billingAddress?.customerName1 && billingAddress?.vat && billingAddress?.isValidVat)
            isValid = true;
        if (!isPro && billingAddress?.customerName1 && billingAddress.customerName2)
            isValid = true;
        // Général
        if (!billingAddress?.street || !billingAddress?.postalCode || !billingAddress?.country || !billingAddress?.city)
            isValid = false;

        return isValid;
    }

    static groupUserSubscriptionConsumptionsPerUsers(userSubscriptionConsumptions = []) {
        let result = [];
        userSubscriptionConsumptions.reduce((res, value) => {
            if (!res[value.userId]) {
                res[value.userId] = { ...value, nbProjects: 1 };
                result.push(res[value.userId])
            } else {
                res[value.userId].nbTrees += value.nbTrees;
                res[value.userId].nbGreenSpaces += value.nbGreenSpaces;
                res[value.userId].nbFurnitures += value.nbFurnitures;
                res[value.userId].nbProjects += 1;
            }
            return res;
        }, {});
        return result;
    }

    // Appartenance de l'utilisateur connecté à une organisation : linkedUsers (organisation active, tenus à jour en temps réel)
    // ou userOrganizations (organisation d'un projet)
    static getOrganizationMembership(organization) {
        const token = new Cookies().get('token');
        if (!token || !organization) return null;
        const userId = jwtDecode(token).id;
        return organization.linkedUsers?.find(user => user.id === userId) || organization.userOrganizations?.find(uo => uo.userId === userId) || null;
    }

    // Propriétaire ou admin : gère les informations, les membres et les assistants IA de l'organisation.
    // L'organisation d'un projet arrive sans ses membres : passer l'organisation active si c'est la même (activeOrganization)
    static canManageOrganization(organization, activeOrganization) {
        if (activeOrganization && organization?.id === activeOrganization.id) organization = activeOrganization;
        const membership = this.getOrganizationMembership(organization);
        return !!(membership?.isOwner || membership?.isAdmin);
    }

    static getDevice() {
        if (isDesktop && isWindows) return { type: 'desktop', os: 'windows', browser: this.getBrowser() };
        else if (isDesktop && isMacOs) return { type: 'desktop', os: 'macOs', browser: this.getBrowser() };
        else if (isDesktop) return { type: 'desktop', os: null, browser: this.getBrowser() };
        else if (isTablet && isAndroid) return { type: 'tablet', os: 'android', browser: this.getBrowser() };
        else if (isTablet) return { type: 'tablet', os: 'ipadOs', browser: this.getBrowser() };
        else if (isMobileOnly && isAndroid) return { type: 'mobile', os: 'android', browser: this.getBrowser() };
        else if (isMobileOnly && isIOS) return { type: 'mobile', os: 'iOs', browser: this.getBrowser() };
        else if (isMobileOnly) return { type: 'mobile', os: null, browser: this.getBrowser() };
        return { type: null, os: null, browser: this.getBrowser() };
    }

    static getBrowser() {
        return isChrome ? 'chrome'
            : isFirefox ? 'firefox'
                : isOpera ? 'opera'
                    : isEdge ? 'edge'
                        : isIE ? 'ie'
                            : isSafari ? 'safari'
                                : null;
    }

    static async setUserPreferences(name, value, userInfos, setUserInfos) {
        const updatedPreferences = { ...userInfos.userPreferences, [name]: value };
        const response = await UsersService.updateUserPreferences(updatedPreferences);
        if (response) setUserInfos({ ...userInfos, userPreferences: updatedPreferences });
        return response;
    }
}